module.exports = __webpack_public_path__ + "img/1547262398.364d4052.jpg";